<template>
  <div class="declare-guide">
    <div class="dec-tit">申报指南</div>
    <div class="dec-cont" v-html="dataHtml"></div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  computed: {
    dataHtml () {
      return this.data?.replace(/\n/g, '<br/>') || ''
    }
  }
}
</script>

<style lang="less" scoped>
.declare-guide {
  overflow: hidden;
  padding: 0 40px 30px;
  .dec-tit {
    padding: 40px 0;
    text-align: center;
    color: #1780BE;
    font-size: 30px;
    font-weight: 600;
    line-height: 38px;
    border-bottom: 1px solid #edeff2;
  }
  .dec-cont {
    margin-top: 12px;
    font-size: 16px;
    color: #505D6E;
    line-height: 32px;
    // text-indent: 32px;
  }
}
</style>
